import type { FC, ReactNode } from "react";
import { twMerge } from "tailwind-merge";
import { Dialog } from "./atoms";

type ModalProps = {
  children: ReactNode;
  open: boolean;
  onOpenChange: (prev: boolean) => void;
  withClose?: boolean;
  className?: string;
  onInteractOutside?: (event: Event) => void;
};

export const Modal: FC<ModalProps> = ({
  open,
  onOpenChange,
  children,
  withClose,
  className,
  onInteractOutside,
}) => (
  <Dialog
    aria-describedby={undefined}
    open={open}
    onOpenChange={onOpenChange}
    withClose={withClose}
    onInteractOutside={onInteractOutside}
    className={twMerge("flex min-w-96 flex-col gap-12", className)}>
    {children}
  </Dialog>
);
